import { createTheme } from '@mui/material/styles';
const CentraNo2Black = require('./css/Fonts/Centra-No2/CentraNo2-Black.otf');
const CentraNo2BlackItalic = require('./css/Fonts/Centra-No2/CentraNo2-BlackItalic.otf');
const CentraNo2Light = require('./css/Fonts/Centra-No2/CentraNo2-Light.ttf');
const CentraNo2Medium = require('./css/Fonts/Centra-No2/CentraNo2-Medium.otf');
const OpenSansRegular = require('./css/Fonts/Centra-No2/OpenSans-Regular.ttf');
const OpenSansSemiBold = require('./css/Fonts/Centra-No2/OpenSans-SemiBold.ttf');
const OpenSansMedium = require('./css/Fonts/Centra-No2/OpenSans-Medium.ttf');
const OpenSansBold = require('./css/Fonts/Centra-No2/OpenSans-Bold.ttf');
const OpenSansLight = require('./css/Fonts/Centra-No2/OpenSans-Light.ttf');
declare module '@mui/material/Button' {
  interface ButtonPropsVariantOverrides {
    login: true;
    outlinedWhite: true;
    outlinedDangerous: true;
    containedPill: true;
    containedPillSelected: true;
  }
}

export const Theme = createTheme({
  palette: {
    primary: {
      main: '#24C3FF',
      dark: '#00AEEF',
      light: 'rgba(0, 174, 239, 0.2)',
      contrastText: '#000',
    },
    secondary: {
      main: '#00B052',
      dark: '#DBD8DF',
      light: 'rgba(19, 103, 11, 0.04)',
      contrastText: '#FFFFFF',
    },
    error: {
      main: '#FF4141',
      dark: '#DB0000',
      contrastText: '#FFF',
    },
  },
  typography: {
    fontFamily: [
      'Centra No2',
      'Centra No2 Light',
      'Centra No2 Black',
      'Centra No2 Black Italic',
      'Open Sans Regular',
      'Open Sans Semi-bold',
      'Open Sans Medium',
      'Open Sans Bold',
      'Open Sans Light',
    ].join(','),
    h1: {
      fontFamily: 'Open Sans Semi-bold',
      fontSize: 42,
      fontStyle: 'normal',
      fontWeight: 600,
      lineHeight: '120%' /* 50.4px */,
      color: '#000',
    },
    h2: {
      fontFamily: 'Open Sans Medium',
      fontSize: 24,
      fontStyle: 'normal',
      fontWeight: 500,
      lineHeight: '120%' /* 28.8px */,
      color: '#000',
      textTransform: 'capitalize',
    },
    h3: {
      fontFamily: 'Open Sans Medium',
      fontSize: 18,
      fontStyle: 'normal',
      fontWeight: 500,
      lineHeight: '120%' /** 21.6px */,
      color: '#FFFFFF',
      textTransform: 'capitalize',
    },
    h4: {
      fontFamily: 'Open Sans Bold',
      fontSize: 14,
      fontStyle: 'normal',
      fontWeight: 700,
      lineHeight: '120%' /** 16.8px */,
      color: '#000',
      textTransform: 'uppercase',
    },
    h5: {
      fontFamily: 'Open Sans Medium',
      fontSize: 14,
      fontStyle: 'normal',
      fontWeight: 500,
      lineHeight: '120%' /** 16.8px */,
      color: '#000',
      textTransform: 'capitalize',
    },
    h6: {
      fontFamily: 'Centra No2 Light',
      fontSize: 14,
      fontStyle: 'normal',
      fontWeight: 300,
      lineHeight: '120%' /** 16.8px */,
      color: '#FFFFFF',
    },
    // paragraph 1
    body1: {
      fontFamily: 'Open Sans Regular',
      fontSize: 16,
      fontStyle: 'normal',
      fontWeight: 400,
      lineHeight: '130%' /** 22.4px */,
      color: '#FFFFFF',
    },
    // paragraph 2
    body2: {
      fontFamily: 'Open Sans Medium',
      fontSize: 18,
      fontStyle: 'normal',
      fontWeight: 500,
      lineHeight: '120%' /** 21.6px */,
      color: '#FFFFFF',
    },
    button: {
      fontFamily: 'Open Sans Medium',
      fontSize: 16,
      fontStyle: 'normal',
      fontWeight: 500,
      lineHeight: '120%' /** 19.2px */,
      color: '#FFFFFF',
    },
    // tags 1
    subtitle1: {
      fontFamily: 'Open Sans Light',
      fontSize: 14,
      fontStyle: 'normal',
      fontWeight: 300,
      lineHeight: '120%' /** 16.8px */,
      color: '#FFFFFF',
    },
    // tags 2
    subtitle2: {
      fontFamily: 'Open Sans Medium',
      fontSize: 12,
      fontStyle: 'normal',
      fontWeight: 500,
      lineHeight: '120%' /** 16.8px */,
      color: '#4D4D4D',
      textTransform: 'capitalize',
    },
    // tags 3
    caption: {
      fontFamily: 'Open Sans Regular',
      fontSize: 14,
      fontStyle: 'normal',
      fontWeight: 400,
      lineHeight: '120%' /** 14.4px */,
      color: '#FFFFFF',
    },
    overline: {},
  },
  components: {
    MuiChip: {
      styleOverrides: {
        root: {
          borderRadius: 0,
          marginRight: 2,
        },
      },
    },
    MuiCssBaseline: {
      styleOverrides: `
      &::-webkit-scrollbar {
        width: 0px;
      }

      &::-webkit-scrollbar-track {
        background: rgba(255, 255, 255, 0.2) ;
      }
      
      &::-webkit-scrollbar-thumb {
        background: rgba(255, 255, 255, 0.4) ;
        border-radius: 2px;
      }
        body {
          margin: 0;
          padding: 0;
          width: 100%;
          height: 100%;
          background-color: #FFF !important;
        }

        @font-face{
          font-family:"Centra No2";
          src:url(${CentraNo2Medium}) format("opentype");
        }
         
        @font-face{
          font-family:"Centra No2 Light";
          src:url(${CentraNo2Light}) format("truetype");
        }
        
       @font-face{
          font-family:"Centra No2 Black";
          src:url(${CentraNo2Black}) format("opentype");
        }
        
        @font-face{
          font-family:"Centra No2 Black Italic";
          src:url(${CentraNo2BlackItalic}) format("opentype");
        }        
        @font-face{
          font-family:"Open Sans Regular";
          src:url(${OpenSansRegular}) format("opentype");
        }        
        @font-face{
          font-family:"Open Sans Semi-bold";
          src:url(${OpenSansSemiBold}) format("opentype");
        }        
        @font-face{
          font-family:"Open Sans Medium";
          src:url(${OpenSansMedium}) format("opentype");
        }        
        @font-face{
          font-family:"Open Sans Bold";
          src:url(${OpenSansBold}) format("opentype");
        }        
        @font-face{
          font-family:"Open Sans Light";
          src:url(${OpenSansLight}) format("opentype");
        }        
      `,
    },
    MuiInputBase: {
      styleOverrides: {
        root: {
          backgroundColor: 'transparent',
          height: 40,
          padding: '8px 16px',
          border: '1px solid rgba(255, 255, 255, 0.4)',
          borderRadius: '4px',
          outline: 'none',
          color: '#FFFFFF',
          '&:focus-within': {
            border: '1px solid white',
          },
          input: {
            backgroundColor: 'transparent',
            marginRight: '15px',
            padding: '8px 16px',
            fontFamily: 'Open Sans Medium',
            fontSize: 16,
            fontStyle: 'normal',
            fontWeight: 300,
            lineHeight: '140%' /** 22.4px */,
            '&:-webkit-autofill': {
              margin: '4px',
              padding: '4px 12px',
              fontFamily: 'Open Sans Medium',
              fontSize: 16,
              fontStyle: 'normal',
              fontWeight: 300,
              lineHeight: '140%' /** 22.4px */,
            },
            '&:focus': {
              backgroundColor: 'transparent',
            },
            '&:hover': {
              backgroundColor: 'transparent',
            },
          },
        },
      },
    },

    MuiDrawer: {
      defaultProps: {
        PaperProps: {
          style: {
            padding: 32,
            minWidth: 400,
            width: 400,
            height: '100%',
            backgroundColor: '#326295',
            boxShadow:
              '0px 8px 10px -5px rgba(255,255,255,0.2),0px 16px 24px 2px rgba(255,255,255,0.14),0px 6px 30px 5px rgba(255,255,255,0.12)',
          },
        },
      },
    },
    MuiSelect: {
      defaultProps: {
        style: {
          backgroundColor: '#FFF',
          //padding: '6px 3px 6px 16px',
          color: '#4D4D4D',
        },
      },
    },
    /*
    MuiPaper: {
      styleOverrides: {
        root: {
          backgroundColor: '#170B28',
        },
      },
    },*/
    MuiButton: {
      variants: [
        {
          props: { variant: 'outlined' },
          style: {
            borderRadius: 8,
            fontSize: 16,
            fontWeight: 500,
            fontStyle: 'normal',
            textTransform: 'capitalize',
            padding: '8px 16px',
            color: '#FFFFFF',
            lineHeight: '120%',
            border: '1.5px solid #FFFFFF',
            '& svg': {
              marginTop: '-6px',
            },
            '&:disabled': {
              color: '#001A24',
              background: '#ccc8c8',
              border: '1.5px solid #001A24',
            },
          },
        },
        {
          props: { variant: 'outlinedWhite' },
          style: {
            borderRadius: 8,
            fontSize: 16,
            textTransform: 'capitalize',
            padding: '8px 16px',
            border: '1.5px solid #00B052',
            color: '#00B052',
            '& svg': {
              fill: '#F4F3F5',
              marginTop: '-6px',
            },
            '&:hover': {
              background: 'rgba(0, 0, 0, 0.20)',
              border: '1.5px solid #00B052',
              color: '#00B052',
            },
            '&:disabled': {
              color: '#00B052',
              border: '1.5px solid #00B052',
              opacity: 0.4,
            },
          },
        },
        {
          props: { variant: 'outlinedDangerous' },
          style: {
            borderRadius: 8,
            fontSize: 16,
            textTransform: 'capitalize',
            padding: '10px 16px 6px 16px',
            border: '1.5px solid #FF4141',
            color: '#FF4141',
            '& svg': {
              fill: '#DB0000',
              marginTop: '-6px',
            },
            '&:hover': {
              background: 'rgba(255, 65, 65, 0.2)',
              border: '1.5px solid #DB0000',
              color: '#DB0000',
              '& svg': {
                fill: '#DB0000',
              },
            },
            '&:disabled': {
              color: '#001A24',
              border: '1.5px solid #001A24',
            },
          },
        },
        {
          props: { variant: 'containedPill' },
          style: {
            borderRadius: 4,
            fontSize: 16,
            textTransform: 'capitalize',
            padding: '8px 16px',
            color: '#262626',
            fontFamily: 'Open Sans Regular',
            fontStyle: 'normal',
            fontWeight: 400,
            lineHeight: '130%' /** 22.4px */,

            background: 'rgba(73, 148, 206, 0.20)',
            '& svg': {
              fill: '#262626',
              marginTop: '-6px',
            },
            '&:hover': {
              background: 'rgba(73, 148, 206, 0.60)',
              color: '#262626',
              '& svg': {
                fill: '#262626',
              },
            },
            '&:disabled': {
              color: '#B3B3B3',
              background: '#001A24',
              '& svg': {
                fill: '#B3B3B3',
              },
            },
            '&.Mui-selected': {
              color: '#000',
              background: '#326295',
              '& svg': {
                fill: '#FFF',
              },
            },
            '&:selected': {
              color: '#000',
              background: '#326295',
              '& svg': {
                fill: '#FFF',
              },
            },
          },
        },
        {
          props: { variant: 'containedPillSelected' },
          style: {
            borderRadius: 4,
            fontSize: 16,
            textTransform: 'capitalize',
            padding: '10px 16px 6px 16px',
            background: '#326295',
            color: '#FFFFFF',
            fontFamily: 'Open Sans Regular',
            fontStyle: 'normal',
            fontWeight: 400,
            lineHeight: '130%' /** 22.4px */,
            '& svg': {
              fill: '#FFF',
              marginTop: '-6px',
            },
            '&:hover': {
              background: '#326295',
              color: '#FFF',
              '& svg': {
                fill: '#FFF',
              },
            },
            '&:disabled': {
              color: '#B3B3B3',
              background: '#001A24',
              '& svg': {
                fill: '#B3B3B3',
              },
            },
          },
        },
        {
          props: { variant: 'contained' },
          style: {
            borderRadius: 8,
            fontSize: 16,
            textTransform: 'capitalize',
            fontWeight: 500,
            fontStyle: 'normal',
            padding: '8px 16px',
            lineHeight: '120%',

            '& svg': {
              marginTop: '-6px',
            },
            '&:disabled': {
              background: '#00B052',
              color: '#fff',
              opacity: 0.4,
            },
            '&:hover': {
              background:
                'linear-gradient(0deg, rgba(0, 0, 0, 0.20) 0%, rgba(0, 0, 0, 0.20) 100%), #00B052',
              color: '#fff',
            },
          },
        },
        {
          props: { variant: 'login' },
          style: {
            background: '#DBD8DF',
            borderRadius: 8,
            boxShadow: 'none',
            fontSize: 16,
            lineHeight: '120%',
            textTransform: 'capitalize',
            color: '#000',
            padding: '10px 16px 6px 16px',
            '& svg': {
              marginTop: '-6px',
            },
            '&:hover': {
              background: '#FFFFFF',
              color: '#000',
            },
          },
        },
        {
          props: { variant: 'text' },
          style: {
            textTransform: 'capitalize',
            fontSize: 14,
            fontWeight: 500,
            lineHeight: '120%',
            borderRadius: '2px',
            color: '#FFFFFF',
            height: 32,
            alignItems: 'flex-end',
            '& svg': {
              marginTop: '-6px',
            },
            '&:hover': {
              background: '#DEE2E6',
              color: '#011E41',
              borderRadius: '4px',
              '& svg': {
                transition: 'all 0.3s',
                fill: '#000000',
              },
            },
          },
        },
      ],
    },
    MuiTab: {
      defaultProps: {
        style: {
          color: '#FFF',
          textTransform: 'capitalize',
          fontFamily: 'Centra No2',
          fontSize: '14px',
          fontStyle: 'normal',
          fontWeight: 500,
          lineHeight: '120%' /* 16.8px */,
        },
      },
    },
    MuiTabs: {
      defaultProps: {
        indicatorColor: 'secondary',
      },
    },
    MuiList: {
      styleOverrides: {
        root: {
          backgroundColor: '#326295',
        },
      },
    },
    MuiListItemButton: {
      defaultProps: {
        disableTouchRipple: true,
        style: {
          padding: '20px 16px',
          fontFamily: 'Open Sans Medium',
        },
      },
      styleOverrides: {
        root: {
          borderBottom: '1px solid rgba(255, 255, 255, 0.20)',
          borderLeft: '4px solid transparent',
          '&:hover': {
            background: 'rgba(255, 255, 255, 0.20)',
            borderRadius: '4px',
          },
          '&.Mui-selected': {
            background: '#326295',
            borderLeft: '4px solid #00B052',
          },
        },
      },
    },
    MuiListItemIcon: {
      defaultProps: {
        style: {
          //color: 'yellow',
          //backgroundColor: 'blue',
          minWidth: 0,
          marginRight: 16,
        },
      },
      styleOverrides: {
        root: {
          '&:hover': {
            //background: '#DEE2E6',
            //color: '#011E41',
            borderRadius: '4px',
          },
        },
      },
    },
    MuiSvgIcon: {
      defaultProps: {
        style: {
          //fontSize: 20,
          color: '#FFFFFF',
        },
      },
    },
    MuiListItemText: {
      styleOverrides: {
        primary: {
          fontFamily: 'Open Sans Medium',
          fontSize: 16,
          fontStyle: 'normal',
          fontWeight: 500,
          lineHeight: '120%' /** 19.2px */,
          color: '#FFFFFF',
        },
      },
    },
    /*
    MuiStepper: {
      styleOverrides: {
        root: {
          '&:nth-child()': {},
        },
      },
    },*/
    MuiPagination: {},
    MuiPaginationItem: {
      defaultProps: {
        style: {
          color: '#262626',
          borderRadius: '2px',
          width: '24px',
          height: '24px',
          minWidth: '24px',
          fontFamily: 'Open Sans',
          fontSize: '16px',
          fontStyle: 'normal',
          fontWeight: 500,
          lineHeight: '120%',
        },
      },
      styleOverrides: {
        root: {
          '&:hover': {
            backgroundColor: 'rgba(73, 148, 206, 0.20)',
            color: '#262626',
          },
          '&.Mui-selected': {
            backgroundColor: '#4994CE',
            color: '#FFF !important',
            '&:hover': {
              backgroundColor: 'rgba(73, 148, 206, 0.20)',
              color: '#262626 !important',
            },
          },
        },
        // Add these overrides for arrow icons
        outlined: {
          '& svg': {
            fill: '#262626', // Ensures arrows have visible color
            cursor: 'pointer',
          },
        },
        text: {
          '& svg': {
            fill: '#262626',
          },
        },
      },
    },
  },
});
